var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('reusable-dialog', {
    model: {
      value: _vm.isVisibleAreaTimezoneList,
      callback: function callback($$v) {
        _vm.isVisibleAreaTimezoneList = $$v;
      },
      expression: "isVisibleAreaTimezoneList"
    }
  }, _vm._l(_vm.timezoneList, function (timezone) {
    return _c('div', {
      key: timezone.id,
      class: _vm.$style.timezone
    }, [_c('option-panel', {
      attrs: {
        "active": timezone.active
      },
      on: {
        "click": function click($event) {
          return _vm.handleSelect(timezone);
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(timezone.displayCode))]), _c('span', {
      class: _vm.$style.time,
      attrs: {
        "slot": "action"
      },
      domProps: {
        "textContent": _vm._s(timezone.timer)
      },
      slot: "action"
    })])], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }